import '../../App.css';
import Stack from '@mui/material/Stack';
import { jsonToTable } from '../../utils/StringUtils';
import Box from '@mui/material/Box';

const RawBoard2Tab = (props) => {
    const { packet } = props;
    
    return (
        <>
            <Stack direction='row' spacing={1}>
                {(packet.board2 !== null) && (
                    <>
                        <Box key="Header">
                            Header
                            {jsonToTable(packet.board2.header)}
                        </Box>
                        <Box key="VVVF1">
                            VVVF1
                            {jsonToTable(packet.board2.vvvf1)}
                        </Box>
                        <Box key="VVVF2">
                            VVVF2
                            {jsonToTable(packet.board2.vvvf2)}
                        </Box>
                        <Box key="DOOR1">
                            DOOR1
                            {jsonToTable(packet.board2.door1)}
                        </Box>
                        <Box key="DOOR2">
                            DOOR2
                            {jsonToTable(packet.board2.door2)}
                        </Box>
                        <Box key="DOOR3">
                            DOOR3
                            {jsonToTable(packet.board2.door3)}
                        </Box>
                        <Box key="Time">
                            Time
                            {jsonToTable(packet.board2.time)}
                        </Box>
                        <Box key="Misc">
                            Misc
                            {jsonToTable(packet.board2.misc)}
                        </Box>
                        <Box key="VDV">
                            VDV
                            {jsonToTable(packet.board2.vdv)}
                        </Box>
                        <Box key="Extra2">
                            Extra2
                            {jsonToTable(packet.board2.extra2)}
                        </Box>
                    </>
                )}
            </Stack>
        </>
    );
};

export default RawBoard2Tab;